import { useEffect } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';
import Markdown from 'markdown-to-jsx';

import { post } from '@rewardopl/utils/network';

import {
  Body,
  HeaderContentWrapper,
  HeaderWrapper,
  MessageDate,
  Picture,
  Sender,
  Subject,
} from './message_content.styles';

import { formatRelative } from '../../../../../utils/date';

import { businessQuery, vendorMessageQuery } from '../../../../../store';

import type { Message } from '@rewardopl/types';

type MessageContentProps = {
  messageId: Message['_id'];
};

export default function MessageContent({ messageId }: MessageContentProps) {
  const [message, setMessage] = useAtom(vendorMessageQuery(messageId));

  const { business_id: businessId } = message;

  const business = useAtomValue(businessQuery(businessId));

  const pictureString = useTranslation('Picture');

  useEffect(() => {
    if (message.is_read) {
      return;
    }

    (async () => {
      const response = await post(`/api/users/current/messages/${messageId}/read`);

      setMessage(response as Message);
    })();
  }, [message.is_read, messageId, setMessage]);

  return (
    <>
      <HeaderWrapper>
        <HeaderContentWrapper>
          <MessageDate>{formatRelative(message.created_at)}</MessageDate>
          <Subject>{message.subject}</Subject>
          <Sender>{business.name}</Sender>
        </HeaderContentWrapper>
      </HeaderWrapper>
      <Body>
        <Markdown>{message.body}</Markdown>
      </Body>
      {message.attachment ? (
        <Picture alt={pictureString} src={`/api/uploads/${message.attachment}`} />
      ) : null}
    </>
  );
}
